import { createAsyncThunk } from '@reduxjs/toolkit';
import { _radiologistUser } from '@custom/Utils/constants/apiUrls';

const radiologistUserApi = createAsyncThunk<any, string>(
  'radiologistUserApi',
  async (data:any) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      let url = `${_radiologistUser.get}?from=${data.from}&modality=${data.modality}`;

      let response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      return await response.json();
    } catch (error) {
      return error;
    }
  }
);

export default radiologistUserApi;
